// extracted by mini-css-extract-plugin
module.exports = {"loader":"_2ePJ6","imgClass":"_1rux-"};